import React from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { NotificationProvider } from './shared/utils/notification/NotificationContext';
import { AppContainer } from './AppContainer';
import ScrollToTop from './shared/utils/ScrollToTop';
import { BehErrorBoundary } from './shared/error/BehErrorBoundary';
import { AppRouter } from './pages/AppRouter';
import {AuthProvider} from "./shared/utils/auth/AuthContext";

function App() {
  const { t } = useTranslation('mc');

  return (
    <NotificationProvider
      defaultModalHeading={t('globalNotifications.modalHeading')}
      defaultModalConfirmationButtonLabel={t(
        'globalNotifications.modalConfirm'
      )}
      defaultModalAbortButtonLabel={t('globalNotifications.modalAboard')}
      defaultModalContent={t('globalNotifications.modalHint')}
      defaultAlertErrorMessage={t('globalNotifications.alertError')}
      defaultAlertSuccessMessage={t('globalNotifications.alertSuccess')}
    >
      <AppContainer>
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <BehErrorBoundary>
              <AppRouter />
            </BehErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </AppContainer>
    </NotificationProvider>
  );
}

export default App;
